
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ChefHat, Home, Menu, Utensils } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background via-background to-accent/5">
      <div className="text-center max-w-md mx-auto px-6">
        {/* French restaurant style icons */}
        <div className="flex justify-center items-center gap-4 mb-8">
          <ChefHat className="h-8 w-8 text-primary animate-pulse" />
          <Utensils className="h-6 w-6 text-accent" />
          <Menu className="h-8 w-8 text-primary animate-pulse" />
        </div>
        
        <h1 className="text-6xl font-bold mb-4 text-primary">404</h1>
        <h2 className="text-2xl font-semibold mb-4 text-foreground">
          Oups ! Cette page n'existe pas
        </h2>
        <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
          On dirait que cette page a quitté la cuisine ! 👨‍🍳<br/>
          Peut-être qu'elle prépare un nouveau plat délicieux ?
        </p>
        
        <div className="space-y-4">
          <Button asChild size="lg" className="w-full">
            <Link to="/">
              <Home className="mr-2 h-5 w-5" />
              Retour à l'accueil
            </Link>
          </Button>
          
          <Button asChild variant="outline" size="lg" className="w-full">
            <Link to="/dashboard">
              <ChefHat className="mr-2 h-5 w-5" />
              Mon tableau de bord
            </Link>
          </Button>
        </div>
        
        <p className="text-sm text-muted-foreground/60 mt-8">
          Besoin d'aide ? Contactez notre équipe support
        </p>
      </div>
    </div>
  );
};

export default NotFound;
